import './template.css';

import { mergeAttributes, Node} from '@tiptap/react';

const ThreeColumnsNode = Node.create({
    name: 'three_columns',
    content: 'single_column single_column single_column',
    group: 'block',
    defining: true,
    draggable: true,

    parseHTML() {
        return [{
            tag: 'div',

            // Parsing priorities start at 50, two columns
            // should be parsed after parsing single columns has failed.
            priority: 60,

            getAttrs: (element) => {
                if (element instanceof HTMLElement) {
                    const type = element.getAttribute('data-type');
                    if (type === 'three-columns') {
                        return null;
                    }
                }

                return false;
            }
        }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(
            this.options.HTMLAttributes,
            HTMLAttributes, {
                class: 'three-columns',
                // These styles: 'display: grid; grid-template-columns: repeat(3, minmax(0, 1fr));',
                // will applied using the generated enhanced content css (check output-template.vm), so we can
                // include media queries.
                'data-type': 'three-columns'
            }), 0];
    },
});

export default ThreeColumnsNode;
